import React from "react";
import {
  Container,
  Title,
  Group,
  Button,
  Text,
  Paper,
  Box,
  Space,
  Grid,
  useMantineTheme,
} from "@mantine/core";
import { Breadcrumbs, Anchor } from "@mantine/core";
import { showNotification } from "@mantine/notifications";

import { IconExclamationMark, IconCircleCheck } from "@tabler/icons";
import { useTranslation } from "react-i18next";

const items = [
  { title: "Home", href: "/" },
  { title: "Setting", href: "/setting/" },
  { title: "Reset Password", href: "/resetPassword" },
].map((item, index) => (
  <Anchor href={item.href} key={index}>
    {item.title}
  </Anchor>
));

export const Page = ({ title, size = "xl", children, actions, hideTitle }) => {
  const { t } = useTranslation();
  const titleContent =
    typeof title === "string" ? <Title align="left">{t(title)}</Title> : title;

  return (
    <Container size={size}>
      {!hideTitle && (
        <>
          <Group position={"apart"}>
            {titleContent}
            <Group>{actions}</Group>
          </Group>
          <Space h="xl" />
        </>
      )}
      {children}
    </Container>
  );
};

export const FormPage = ({ children, title, actions }) => {
  return (
    <form>
      <Page title={title} actions={actions()}>
        {children}
      </Page>
    </form>
  );
};

export const FormSectionCard = ({
  children,
  title,
  description,
  withPaper = true,
  h,
  paperPadding = "xl",
  titleMb = "xs",
  ...props
}) => {
  const { t } = useTranslation();
  const theme = useMantineTheme();
  const header = (
    <>
      {title ? (
        <Text
          transform="uppercase"
          size="xs"
          weight={600}
          color="gray.7"
          mb={description ? 4 : titleMb}
        >
          {t(title)}
        </Text>
      ) : null}
      {description ? (
        <Text size="xs" color="dimmed" mb="xs">
          {t(description)}
        </Text>
      ) : null}
    </>
  );
  return (
    <Box
      mb="xl"
      {...props}
      style={{
        "@media print": {
          display: "block",
          "page-break-before": "always",
        },
      }}
    >
      {header}
      {!withPaper && children}
      {withPaper && (
        <Paper
          shadow={theme.colorScheme === "light" ? "sm" : "md"}
          p={paperPadding}
          radius={0}
          h={h}
          sx={{
            ...(theme.colorScheme === "light"
              ? {
                  border: `1px solid ${theme.colors.gray[3]}`,
                }
              : {}),
          }}
        >
          {children}
        </Paper>
      )}
    </Box>
  );
};

export const useFormNotification = () => {
  const notifyFormSuccess = ({
    title = "Saved",
    message = "Data submitted successfully.",
  }) => {
    return showNotification({
      title,
      // color: "red",
      icon: <IconCircleCheck size={18} />,
      message,
    });
  };

  const notifyFormError = ({
    title = "Error",
    message = "Form submit error",
  }) => {
    return showNotification({
      title,
      color: "red",
      icon: <IconExclamationMark size={18} />,
      message,
    });
  };

  return [notifyFormSuccess, notifyFormError];
};
